import {
  ErrorComponentProps,
  ErrorComponent as TantstackErrorComponent,
} from "@tanstack/react-router";

export function ErrorComponent({ error, reset, info }: ErrorComponentProps) {
  if (import.meta.env.DEV) {
    return (
      <div className="w-full [&>div>div>pre]:text-wrap">
        <button
          className="mt-2 ml-2 rounded-sm border border-black p-1 text-xs font-medium"
          onClick={reset}
        >
          Reset state
        </button>
        <TantstackErrorComponent error={error} />
        {info && (
          <details className="p-2">
            <summary className="cursor-pointer">Component stack</summary>
            <pre className="whitespace-pre-wrap">{info.componentStack}</pre>
          </details>
        )}
      </div>
    );
  }
}
